import { fetcher } from '@commenda/utils';

export async function createComplianceMonitor(
  corporationId: number
): Promise<Response> {
  return await fetcher('compliance-monitors', {
    method: 'POST',
    body: {
      corporationId,
    },
  });
}
